"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolflareAdapter = void 0;
const tslib_1 = require("tslib");
const sol_wallet_adapter_1 = (0, tslib_1.__importDefault)(require("@project-serum/sol-wallet-adapter"));
const tiny_invariant_1 = (0, tslib_1.__importDefault)(require("tiny-invariant"));
class SolflareAdapter extends sol_wallet_adapter_1.default {
    constructor() {
        super(...arguments);
        this.signAllTransactions = (txs) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const ret = [];
            for (let i = 0; i < txs.length; i++) {
                const tx = txs[i];
                (0, tiny_invariant_1.default)(tx, "tx");
                const signedTx = yield this.signTransaction(tx);
                ret.push(signedTx);
            }
            return ret;
        });
    }
}
exports.SolflareAdapter = SolflareAdapter;
//# sourceMappingURL=solflare.js.map